<template>
  <div class="adminPickingReadingMd">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ picking }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ reading }}</router-link>
      </li>
    </ol>
    <div class="container-fluid">
      <div class="card">
        <div class="card-header" v-if="barcodeReaderData == ''">
          <div class="row">
            <div class="col">{{ reading }}</div>
          </div>
        </div>
        <div class="card-body" style="padding: 1.25rem" v-if="barcodeReaderData == ''">
          <div id="dManualInput" v-if="manualInput">
            <form id="frmBarcodeReader" @submit.prevent="submitBarcode" action="#">
              <div class="row">
                <div class="col-sm-12 col-lg-6">
                  <input
                    type="text"
                    name="txtBarcodeReader"
                    ref="txtBarcodeReader"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-sm-12 col-lg-1">
                  <button class="btn btn-success btn-block" type="submit">
                    <i class="fa fa-floppy-o"></i>
                    {{ read }}
                  </button>
                </div>
                <div class="col-sm-12 col-lg-5">
                  <button
                    class="btn btn-primary btn-block"
                    @click="clickEnableScanner"
                    type="button"
                  >
                    <i class="fa fa-barcode"></i>
                    {{ enableScanner }}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div id="scannerInput" v-if="!manualInput">
            <div class="row">
              <div class="col">
                <barcodeReader :value.sync="barcodeReaderData"></barcodeReader>
              </div>
            </div>
            <div class="row">
              <div class="col text-right">
                <button class="btn btn-success btn-block" @click="clickDisableScanner">
                  <i class="fa fa-barcode"></i>
                  {{ disableScanner }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarcodeReader from "@/components/BarcodeReader.vue";

export default {
  name: "adminPickingReadingMd",
  components: {
    BarcodeReader
  },
  data() {
    return {
      admin: dictionaryHelpers.getDictionary("Admin"),
      addPackage: dictionaryHelpers.getDictionary("AddPackage"),
      enableScanner: dictionaryHelpers.getDictionary("EnableScanner"),
      barcodeReaderData: "",
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      close: dictionaryHelpers.getDictionary("Close"),
      confirmAddPackage: dictionaryHelpers.getDictionary("ConfirmAddPackage"),
      confirmCancel: dictionaryHelpers.getDictionary("ConfirmCancel"),
      confirmClose: dictionaryHelpers.getDictionary("ConfirmClose"),
      confirmSave: dictionaryHelpers.getDictionary("ConfirmSave"),
      disableScanner: dictionaryHelpers.getDictionary("DisableScanner"),
      documentCode: "",
      idFrmAdminPickingReading: "frmAdminPickingReading",
      idFrmBarcodeReader: "frmBarcodeReader",
      item: dictionaryHelpers.getDictionary("Item"),
      itemAlreadyPicked: dictionaryHelpers.getDictionary("ItemAlreadyPicked"),
      label_order_quantity: dictionaryHelpers.getDictionary("OrderQuantity"),
      label_order_picking: dictionaryHelpers.getDictionary("OrderPicking"),
      label_package: dictionaryHelpers.getDictionary("Package"),
      manualInput: true,
      order: dictionaryHelpers.getDictionary("Order"),
      picking: dictionaryHelpers.getDictionary("Picking"),
      reading: dictionaryHelpers.getDictionary("Reading"),
      read: dictionaryHelpers.getDictionary("Read"),
      startReading: dictionaryHelpers.getDictionary("StartReading"),
      save: dictionaryHelpers.getDictionary("Save"),
      url: window.location.pathname,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted")
    };
  },
  watch: {
    barcodeReaderData: function(newVal, oldVal) {
      spinnerHelpers.show();
      var adminPickingReadingSixten = this;

      if (functionHelpers.isValued(newVal)) {

      }
    },
    $route(to, from) {
      if (!functionHelpers.isValued(to.params.id)) {
        this.barcodeReaderData = "";
      }
    }
  },
  mounted() {
    this.$refs.txtBarcodeReader.focus();
    /*validationHelpers.validateBase($("#" + this.idFrmBarcodeReader));
    validationHelpers.validateBase($("#" + this.idFrmAdminPickingReading));*/
  },
  methods: {
    /*** READING ***/

    clickDisableScanner() {
      var adminPickingReadingSixten = this;
      this.manualInput = true;
      setTimeout(function() {
        adminPickingReadingSixten.$refs.txtBarcodeReader.focus();
      }, 500);
    },
    clickEnableScanner() {
      this.manualInput = false;
    },
    submitBarcode() {
      if (validationHelpers.isValid($("#" + this.idFrmBarcodeReader))) {
        this.barcodeReaderData = this.$refs.txtBarcodeReader.value;
      }
    },
    executeConfirmCancel() {
      spinnerHelpers.show();
      this.$router.push({
        path: `/admin/picking/readingmd`
      });
      spinnerHelpers.hide();
    }
    // executeConfirmClose() {
    //   if (confirm(this.confirmClose)) {
    //     this.executeClose();
    //   }
    // },
    // executeClose() {
    //   spinnerHelpers.show();
    //   notificationHelpers.success(this.updateCompleted);
    //   this.barcodeReaderData = "";
    //   spinnerHelpers.hide();
    // }
  }
};
</script>

<style>
hr {
  color: #f0f3f5;
}
</style>
